export enum EnvFeaturesEnum {
  DASHBOARD_CA_SUPPLIER_FEATURE = 'DASHBOARD_CA_SUPPLIER_FEATURE',
  IMPORT_QUOTA_FEATURE = 'IMPORT_QUOTA_FEATURE',
  DASHBOARD_CA_TC_FEATURE = 'DASHBOARD_CA_TC_FEATURE',
  CLICK_AND_COLLECT_FEATURE = 'CLICK_AND_COLLECT_FEATURE',
  DISCOUNT_SEGMENT_FEATURE = 'DISCOUNT_SEGMENT_FEATURE',
  DISCOUNT_FLASH_SALE_FEATURE = 'DISCOUNT_FLASH_SALE_FEATURE',
  DISCOUNT_SALES_FEATURE = 'DISCOUNT_SALES_FEATURE',
  DISCOUNT_META_FEATURE = 'DISCOUNT_META_FEATURE',
  PAYMENT_DUE_DATES_FEATURE = 'PAYMENT_DUE_DATES_FEATURE',
  COMPANIES_FEATURE = 'COMPANIES_FEATURE',
  ORDERS_TO_VALIDATE_FEATURE = 'ORDERS_TO_VALIDATE_FEATURE',
  LOGISTIC_CONFIG_FEATURE = 'LOGISTIC_CONFIG_FEATURE',
  PRODUCT_MANAGEMENT_FEATURE = 'PRODUCT_MANAGEMENT_FEATURE',
}
